import { defineStore } from "pinia";

import { useSessionClear } from "@/plugins/store/composables/useSessionClear";

export const usePiniaStore = defineStore("store", () => {
    const {
        clearSessionData,
        clearSessionDataForAnotherPayment,
        clearSessionDataForRetryPayment,
    } = useSessionClear();

    return {
        clearSessionData,
        clearSessionDataForAnotherPayment,
        clearSessionDataForRetryPayment,
    };
});

export { useSessionStore } from "@/plugins/store/session";
export { useOrganisationStore } from "@/plugins/store/organisation";
export { useCheckoutStore } from "@/plugins/store/checkout";
export { usePaymentsStore } from "@/plugins/store/payments";
export { useTruelayerStore } from "@/plugins/store/providers/truelayer";
export { useVoltStore } from "@/plugins/store/providers/volt";
export { useLloydsStore } from "@/plugins/store/providers/lloyds";
export { useAdyenStore } from "@/plugins/store/providers/adyen";
export { useIFXStore } from "@/plugins/store/providers/ifx";
export { useEMandatesStore } from "@/plugins/store/providers/emandates";
export { useSessionClear } from "@/plugins/store/composables/useSessionClear";
